import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Box, Grid, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { ScaleLoader } from 'react-spinners';
import { ApplicationContext } from '../../../context/Contexts';
import { useTranslate } from '../../../hooks/useTranslate';
import { WorkflowSectionStepForm } from '../../../interfaces/Workflow';
import { FnolDamagePartDto } from '../../../interfaces/Case';
import DamagePartCard from './components/DamagePartCard';

export interface DamagePartPhotosFormProps extends RouteComponentProps<{ id: string }> {
  workflowForm: WorkflowSectionStepForm;
}

const DamagePartPhotosForm: React.FC<DamagePartPhotosFormProps> = ({ match }) => {
  const { caseService } = React.useContext(ApplicationContext);
  const { enqueueSnackbar } = useSnackbar();
  const t = useTranslate();
  const caseId = Number.parseInt(match.params.id);

  const [damagedParts, setDamagedParts] = React.useState<FnolDamagePartDto[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  const loadData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await caseService.GetDamageParts(caseId, true);
      setDamagedParts(response?.damagedParts || []);
    } catch {
      enqueueSnackbar(t('ERROR_MSG', 'Eroare'), { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }, [caseService, caseId, enqueueSnackbar, t]);

  React.useEffect(() => {
    loadData();
  }, [loadData]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <ScaleLoader color={'var(--primary)'} loading={isLoading} />
      </Box>
    );
  }

  return (
    <Box p={3}>
      {damagedParts.length ? (
        <Grid container spacing={2}>
          {damagedParts.map((part) => (
            <Grid item xs={12} key={part.id}>
              <DamagePartCard part={part} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography color="textSecondary">
          {t('NO_DAMAGED_PARTS', 'Nu există piese avariate pe dosar.')}
        </Typography>
      )}
    </Box>
  );
};

export default DamagePartPhotosForm;
